<ng-container *ngIf='fileFormControl'>
  <input #fileUpload class='display--none' type='file' [multiple]='multiple' [formControl]='fileControl()' (change)="onFileChanged($event)" />
  <button mat-flat-button color='{{ buttonType }}' (click)="fileUpload.click()">{{ buttonLabel }}</button>

  <ng-container *ngIf='!multiple'>
    <div class='row no-gap justify-items-center mt--sm' *ngIf='uploadedFile && uploadedFile.name'>
      <div class='column--12 pb--none'>
        <span class='text--sm'>{{ uploadedFile.name }}</span>
        <button mat-icon-button class='mat-inline-icon text--danger' (click)='removeFile()'><mat-icon>close</mat-icon></button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf='multiple'>
    <div class='row no-gap justify-items-center mt--sm' *ngFor='let file of uploadedFiles; let i = index'>
      <div class='column--12 pb--none'>
        <span class='text--sm'>{{ file.name }}</span>
        <button mat-icon-button class='mat-inline-icon text--danger' (click)='removeFile(i)'><mat-icon>close</mat-icon></button>
      </div>
    </div>
  </ng-container>
</ng-container>
